import { NgModule } from '@angular/core';
import { FilterTablePipe } from './filter-table.pipe';

@NgModule({
  declarations: [FilterTablePipe],
  exports: [FilterTablePipe],
})
export class FilterTablePipeModule {}
